import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import {
  LinkOptions,
  linksMap,
} from "components/release/useful-links/helpers/linksMap";
import type { SemVer } from "util/version";

// Generate list of links for Play Console ANRs for minor build version
export const generatePlayConsoleANRLinks = (
  versions: SemVer[],
): JSX.Element[] =>
  generateLinksBase(
    versions,
    strings.PlayConsoleANRs,
    linksMap[LinkOptions.PLAY_CONSOLE_ANR],
  );
